import { Link } from "react-router-dom";

/**
 * Shown under the product name field when another product already carries the
 * same name. Not a hard block on its own — the forms also refuse to save.
 */
export const DuplicateNameNotice = ({ match }) => {
  if (!match) return null;

  return (
    <div
      style={{
        margin: "6px 0 12px",
        padding: "10px 14px",
        border: "1px solid #e0a800",
        borderLeft: "4px solid #e0a800",
        borderRadius: "4px",
        background: "#fff8e5",
        fontSize: "13px",
        lineHeight: 1.5,
        color: "#5c4700",
      }}
    >
      <strong>Това заглавие вече се използва.</strong>
      <div style={{ marginTop: 4 }}>
        Google не може да различи две страници с еднакво име и индексира само
        едната. Добави нещо отличително – цвят, размер, име или мотив.
      </div>
      <Link
        to={`/catalog/${match.id}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "inline-block", marginTop: 6, color: "#8a6b00" }}
      >
        Виж съществуващия продукт →
      </Link>
    </div>
  );
};
